import { Button, Modal, Popconfirm } from 'antd';
import React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Link } from 'react-router-dom';
import '../../components/Notify/NotifyAlert.css';
import PartnerInfo from '../../components/Partner/Info';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import MyUtil from '../../functions/MyUtil';

export default class ButtonFormatter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      edit: false,
      detailPartner: '',
    };

    this.toggle = this.toggle.bind(this);
  }

  async toggle() {
    if (!this.state.detailPartner) {
      var detail = await PartnerApi.getDetailPartner(this.props.row.part_id);
      this.setState({ detailPartner: detail });
    }
    this.setState({
      modal: !this.state.modal,
    });
  }
  handleDelete = async (props) => {
    await PartnerApi.deletePartner(this.props.row.part_id);
    const list = await PartnerApi.getAll();
    await this.props.onChangeList(list);
  };

  handleEdit = () => {
    this.setState({
      edit: !this.state.edit,
    });
  };

  render() {
    const partner = this.state.detailPartner;
    const canAdd = MyUtil.hasPermission('/partner', 'add');
    const canDelete = MyUtil.hasPermission('/partner', 'delete');
    return (
      <div className="div-edit">
        {canAdd && (
          <Link to={'/partner/edit-partner/' + this.props.row.part_id}>
            <Button size="small" onClick={() => this.handleEdit()}>
              <i className="fas fa-edit"></i>
            </Button>
          </Link>
        )}

        <Button
          size="small"
          style={{ marginLeft: '2px', marginRight: '2px' }}
          onClick={() => this.toggle()}
        >
          <i className="fas fa-info"></i>
        </Button>

        {canDelete && (
          <Popconfirm
            title="Bạn chắc chắn muốn xóa?"
            onConfirm={() => this.handleDelete()}
          >
            <Button size="small" danger>
              <i className="fas fa-trash"></i>
            </Button>
          </Popconfirm>
        )}

        <Modal
          visible={this.state.modal}
          onCancel={this.toggle}
          width="80vw"
          title="Chi tiết đối tác"
        >
          {partner && (
            <>
              <PartnerInfo.Basic partner={partner} />
              <PartnerInfo.PriceAndFee partner={partner} />
              <div className="row mt-3">
                <div className="col-6">
                  <PartnerInfo.Procedure partner={partner} />
                </div>
                <div className="col-6">
                  <PartnerInfo.Policy partner={partner} />
                </div>
              </div>
            </>
          )}
        </Modal>
      </div>
    );
  }
}
